import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';

import {
  GQLGeometryType,
  GQLParty,
  GQLPieceAssetInput
} from '@jewelutions/core-crm-server-api-client-domain';

import { JwlCheckbox, JwlField, JwlSelect } from '../../../../components';
import { SelectOption } from '../../../../components/JwlSelect/JwlSelect';

import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { stringListToDisplayValueList } from '../../../../core/utils';
import { ErrorMessage } from '../../../../types-hack';

interface IProps {
  party: GQLParty;
  onClose: (success: boolean) => void;
}

const availableGeometries: SelectOption[] = stringListToDisplayValueList(Object.keys(GQLGeometryType));

const PieceCreateDialog: React.FC<IProps> = ({ party, onClose }) => {
  const [createPiece, { error, loading }] = GQLOperationBuilder.piece.createPiece();

  const initialValues = {
    public: true,
    title: '',
    description: '',
    geometryType: GQLGeometryType.Round
  };

  const onSubmit = (props: any) => {
    const input: GQLPieceAssetInput = {
      description: { en: props.description },
      title: { en: props.title },
      geometryType: props.geometryType,
      ownerPartyId: party.id,
      public: true
    };

    const mutationVariables = { input: input };
    createPiece({ variables: mutationVariables }).then(_result => {
      onClose(true);
    });
  };

  const validationSchema = Yup.object().shape({
    description: Yup.string().required('Description is required'),
    title: Yup.string().required('Title is required')
  });

  return (
    <Dialog open maxWidth="md" aria-labelledby="create-update-piece">
      <DialogTitle>{`Create piece`}</DialogTitle>
      <DialogContent className="w-dialog-small">
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
          {({ values, handleSubmit }) => (
            <form onSubmit={handleSubmit} className="flex flex-col">
              <Field name={`title`} component={JwlField} label="Title" />
              <ErrorMessage component="span" name={`title`} className="fs-12 text-error" />

              <Field name={`description`} component={JwlField} label="Description" />
              <ErrorMessage component="span" name="description" className="fs-12 text-error" />

              <Field
                name="geometryType"
                component={JwlSelect}
                label="Geometry"
                options={availableGeometries}
              />

              <Field name="public" component={JwlCheckbox} label="Public" />

              <DialogActions>
                <Button color="primary" onClick={() => onClose(false)}>
                  Close
                </Button>
                <Button type="submit" color="primary" variant="contained">
                  Save
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default PieceCreateDialog;
